<div class="mobile-navbar">
  <div class="wrapper">
    <app-logo [logoImage]="'assets/logo/purple/spp-logo.svg'" />
  </div>
</div>
